// extracted by mini-css-extract-plugin
export default {"iFrame":"PdfEditor_iFrame__5giTw"};